import React from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as LoginActions } from 'redux/domain/User';
import { actions as cartActions } from 'redux/domain/Cart';
import IndeterminateCircularProgress from 'shared/components/IndeterminateCircularProgress';
import Customer from 'models/Customer';
import { cancelRequest, getCancelTokenSource } from 'api/Helpers';
import KioskLog from 'models/KioskLog';
import EmailCartForm from '../components/EmailCartForm';

/**
 * Allow the user to Log into eSTORIS.
 */
class EmailCartContainer extends React.Component {
	constructor() {
		super();

		this.cancelTokenSource = getCancelTokenSource();
		this.emailCart = this.emailCart.bind(this);
		this.closeEmailCart = this.closeEmailCart.bind(this);
	}

	componentWillReceiveProps() {}

	componentWillUnmount() {
		// if a request is in progress stop it.
		cancelRequest(this.cancelTokenSource);
	}

	closeEmailCart() {
		this.props.closeEmailCart();
	}
	emailCart(cancelToken, loggedin, email, customerEmail, customerName) {
		const { emailCart, customer } = this.props;
		try {
			this.cancelTokenSource = getCancelTokenSource();

			emailCart(this.cancelTokenSource.token, customer.id, email, customerEmail, customerName);
		} catch (e) {
			const log = new KioskLog(e, `customer=${customer.id}`);
			log.postMessage();
		}
	}

	render() {
		const { customer, emailCartOpenLogin, isEmailingCart, emailCartMessage } = this.props;
		return (
			<div>
				<EmailCartForm
					cancelToken={this.cancelTokenSource.token}
					customer={customer}
					emailCart={this.emailCart}
					LoginSingup={emailCartOpenLogin}
					emailCartMessage={emailCartMessage}
					closeEmailCart={this.closeEmailCart}
				/>

				<IndeterminateCircularProgress size={50} isVisible={isEmailingCart} />
			</div>
		);
	}
}

EmailCartContainer.propTypes = {
	customer: PropTypes.instanceOf(Customer).isRequired,
	emailCartMessage: PropTypes.string.isRequired,
	isEmailingCart: PropTypes.bool.isRequired,
	emailCart: PropTypes.func.isRequired,
	closeEmailCart: PropTypes.func.isRequired,
	emailCartOpenLogin: PropTypes.func.isRequired,
};

EmailCartContainer.defaultProps = {};

const mapStateToProps = state => {
	const customer = state.user.get('customer');
	const emailCartMessage = state.cart.get('emailCartMessage');
	const isEmailingCart = state.cart.get('isEmailingCart');
	const emailCartError = state.cart.get('emailCartError');
	return {
		customer,
		emailCartMessage,
		isEmailingCart,
		emailCartError,
	};
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ ...LoginActions, ...cartActions }, dispatch);

// for testing purposes
export { EmailCartContainer as EmailCartContainerClass };

// connect returns a function that accepts a component
export default connect(mapStateToProps, mapDispatchToProps)(EmailCartContainer);
